import { Injectable } from '@angular/core';
import { Headers} from '@angular/http';
import { ServiceConfig } from './service-config';
import { HttpClient } from '@angular/common/http';
@Injectable()
export class SmmService {

  private host = ServiceConfig.host;
  private baseUrl = this.host + '/api/ipcc';
  private url_article_topic = this.host + '/api/ipcc/articleTopic/';
  private url_pain_point = this.host + '/api/pain-point';
  private data: any;
  headers: Headers;

  constructor(private http: HttpClient) {
    this.data = JSON.parse(localStorage.getItem('currentSmmData'));
    this.headers = new Headers({
      'Content-Type': 'application/json'
    });
  }

  public getPagesByIds(ids: Array<String>) {
    const url = this.baseUrl + '/page/mget?token=' + this.data.token;
    return this.http.post<any>(url, { ids: ids });
  }
  public getGroupsByIds(ids: Array<String>) {
    const url = this.baseUrl + '/group/mget?token=' + this.data.token;
    return this.http.post<any>(url, { ids: ids });
  }

  public getPageById(id: String) {
    let url = this.baseUrl + '/page/get/' + id + '?token=' + this.data.token;

    return this.http.get<any>(url);
  }

  public getGroupById(id: String) {
    let url = this.baseUrl + '/group/get/' + id + '?token=' + this.data.token;

    return this.http.get<any>(url);
  }

  public getUserById(id: String) {
    let url = this.baseUrl + '/user/get/' + id + '?token=' + this.data.token;
    return this.http.get<any>(url);
  }

  public getPainPoint () {
    let url = this.url_pain_point + '/getList' + '?token=' + this.data.token;
    return this.http.get<any>(url);
  }

  public getUsersByIds(ids: Array<String>) {
    let url = this.baseUrl + '/user/mget?token=' + this.data.token;

    return this.http.post<any>(url, { ids: ids });
  }

  public getPosts(body) {
    let url = this.baseUrl + '/post/search?token=' + this.data.token;

    return this.http.post<any>(url, body);
  }

  public getPostsByType(body) {
    let url = this.baseUrl + '/post/searchByType?token=' + this.data.token;
    return this.http.post<any>(url, body);
  }
  public getDataByType(body) {
    let url = this.baseUrl + '/post/searchDataByType?token=' + this.data.token;

    return this.http.post<any>(url, body);
  }
  public getAllOrder(body) {
    let url = this.host + '/potential-customers-order-list/getAllOrder?token=' + this.data.token;

    return this.http.post<any>(url,body);
  }

  public groupArticleTopic(body) {
    let url = this.url_article_topic + '/getArticleTopicV2?token=' + this.data.token;
    return this.http.post<any>(url, body);
  }

  public getArticleTopic(body) {
    let url = this.url_article_topic + '/getArticleTopic?token=' + this.data.token;
    return this.http.post<any>(url, body);
  }

  public getDetailDiscussion(body) {
    let url = this.baseUrl + '/post/getDetailDiscussion?token=' + this.data.token;

    return this.http.post<any>(url, body);
  }

  public getRecentPost(body) {
    let url = this.baseUrl + '/post/getRecentPost?token=' + this.data.token;
    return this.http.post<any>(url, body);
  }
  public getPostByKeyword(body) {
    let url = this.baseUrl + '/post/getPostByKeyword?token=' + this.data.token;
    return this.http.post<any>(url, body);
  }

  public groupByPainPoint(body) {
    let url = this.baseUrl + '/post/groupByPainPoint?token=' + this.data.token;
    return this.http.post<any>(url, body);
  }

  public getTrademarkData(body) {
    let url = this.baseUrl + '/post/getTrademarkData?token=' + this.data.token;
    return this.http.post<any>(url, body);
  }

  public getPostsDiscussionSource(body) {
    let url = this.baseUrl + '/post/dashboardDiscussionSource?token=' + this.data.token;
    return this.http.post<any>(url, body);
  }

  public getPostsDiscussionProject(body) {
    let url = this.baseUrl + '/post/dashboardDiscussionProject?token=' + this.data.token;
    return this.http.post<any>(url, body);
  }

  public getPostsDiscussionEvolution(body) {
    let url = this.baseUrl + '/post/dashboardDiscussionEvolution?token=' + this.data.token;
    return this.http.post<any>(url, body);
  }

  public getDiscussionShade(body) {
    let url = this.baseUrl + '/post/dashboardDiscussionShade?token=' + this.data.token;
    return this.http.post<any>(url, body);
  }

  public getAuthorPortrait(body) {
    let url = this.baseUrl + '/post/dashboardAuthorPortrait?token=' + this.data.token;
    return this.http.post<any>(url, body);
  }

  public getPostsByGroup(body) {
    let url = this.baseUrl + '/post/searchByGroup?token=' + this.data.token;
    return this.http.post<any>(url, body);
  }

  // TMHIEP
  public getPostsById(id: String, body) {
    let url = this.baseUrl + '/post/' + id + '?token=' + this.data.token;
    console.log("getPostsById: " + url);
    return this.http.post<any>(url, body);
  }

  // TMHIEP
  public getPostsByIdAndIndex(id: String, postIndex: String, body) {
    let url = this.baseUrl + '/post/' + id + '/' + postIndex + '?token=' + this.data.token;
    console.log("getPostsByIdAndIndex: " + url);
    return this.http.post<any>(url, body);
  }

  public getComments(body) {
    let url = this.baseUrl + '/comment/search?token=' + this.data.token;
    // console.log(url);
    // console.log(body);
    return this.http.post<any>(url, body);
  }

  public getUsers(body) {
    let url = this.baseUrl + '/user/search?token=' + this.data.token;

    return this.http.post<any>(url, body);
  }

  public getGroups(body) {
    let url = this.baseUrl + '/group/search?token=' + this.data.token;

    return this.http.post<any>(url, body);
  }

  public getVideos(body) {
    let url = this.baseUrl + '/youtube/search?token=' + this.data.token;
    return this.http.post<any>(url, body);
  }
  //viettung tra loi binh luan
  public replyComment(body) {
    console.log('smm serive replyComment===>', body);
    let url = this.baseUrl + '/post/replyComment?token=' + this.data.token;
    return this.http.post<any>(url, body);
  }

  public editComment(body) {
    let url = this.baseUrl + '/post/editComment?token=' + this.data.token;
    return this.http.post<any>(url, body);
  }
  public sharePost(body) {
    let url = this.baseUrl + '/post/sharePost?token=' + this.data.token;
    return this.http.post<any>(url, body);
  }



  public deleteComment(body) {
    console.log('smm serive deleteComment===>', body);
    let url = this.baseUrl + '/post/deleteComment?token=' + this.data.token;
    return this.http.post<any>(url, body);
  }


  public getListGroupPriority(body) {
    let url = this.baseUrl + '/group/getListGroupPriority?token=' + this.data.token;

    // return this.http.get(url, this.options).map((response: Response) => response.json());
    return this.http.post<any>(url, body);
  }


  public deleteGroup(body) {
    let url = this.baseUrl + '/group/deleteGroup?token=' + this.data.token;
    return this.http.post<any>(url, body);
  }


  public getCountPostCommentIsProcess(body) {
    let url = this.baseUrl + '/post/getCountPostCommentIsProcess?token=' + this.data.token;
    return this.http.post<any>(url, body);
  }
  public getCountCommentIsProcess(body) {
    let url = this.baseUrl + '/comment/getCountCommentIsProcess?token=' + this.data.token;
    return this.http.post<any>(url, body);
  }

  public likeComment(body) {
    console.log('smm serive likeComment vào đến đây===>');
    //console.log(body);
    let url = this.baseUrl + '/post/likeComment?token=' + this.data.token;
    return this.http.post<any>(url, body);
  }

  public likePost(body) {
    console.log('smm serive likePost vào đến đây===>');
    console.log(body);
    let url = this.baseUrl + '/post/likePost?token=' + this.data.token;
    return this.http.post<any>(url, body);
  }

  //badv like binh luan
  public dislikeComment(body) {
    //console.log(body);
    let url = this.baseUrl + '/post/dislikeComment?token=' + this.data.token;
    return this.http.post<any>(url, body);
  }

  //badv like binh luan
  public dislikePost(body) {
    //console.log(body);
    let url = this.baseUrl + '/post/dislikePost?token=' + this.data.token;
    return this.http.post<any>(url, body);
  }

  public searchPost(body) {
    let url = this.baseUrl + '/post/searchPost?token=' + this.data.token;
    return this.http.post<any>(url, body);
  }

  public getHistorySeeding(body) {
    let url = this.baseUrl + '/post/getHistorySeeding?token=' + this.data.token;
    return this.http.post<any>(url, body);
  }

  public ttdtReport(body) {
    let url = this.baseUrl + '/post/ttdtReport?token=' + this.data.token;
    return this.http.post<any>(url, body);
  }

  public keywordReport(body) {
    let url = this.baseUrl + '/post/keywordReport?token=' + this.data.token;
    return this.http.post<any>(url, body);
  }

  public fanpaheReport(body) {
    let url = this.baseUrl + '/post/fanpage-report?token=' + this.data.token;
    return this.http.post<any>(url, body);
  }

  public dgdvReport(body) {
    let url = this.baseUrl + '/post/dgdvReport?token=' + this.data.token;
    return this.http.post<any>(url, body);
  }

  public dgcdReport(body) {
    let url = this.baseUrl + '/post/dgcdReport?token=' + this.data.token;
    return this.http.post<any>(url, body);
  }
  public tkhdReport(body) {
    let url = this.baseUrl + '/post/tkhd?token=' + this.data.token;
    return this.http.post<any>(url, body);
  }

  public e14sentimentReport(body) {
    let url = this.baseUrl + '/post/e14-sentiment-report?token=' + this.data.token;
    return this.http.post<any>(url, body);
  }
  public e14TopContentReport(body) {
    let url = this.baseUrl + '/post/e14-top-content-report?token=' + this.data.token;
    return this.http.post<any>(url, body);
  }

  public lhbdReport(body) {
    let url = this.baseUrl + '/post/lhbd?token=' + this.data.token;
    return this.http.post<any>(url, body);
  }

  public searchPostNegative(body) {
    let url = this.baseUrl + '/post/searchPostNegative?token=' + this.data.token;
    return this.http.post<any>(url, body);
  }

  public searchCommentNegative(body) {
    let url = this.baseUrl + '/comment/searchCommentNegative?token=' + this.data.token;
    return this.http.post<any>(url, body);
  }

  public getPostsDiscussionProvince(body) {
    let url = this.baseUrl + '/post/dashboardDiscussionProvince?token=' + this.data.token;
    return this.http.post<any>(url, body);
  }
}



// WEBPACK FOOTER //
// D:/Project/Nodejs/SocialListening_Cloud/frontend_cloud/src/app/_services/smm.service.ts